import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL, API_FILE_URL } from "../../api/config";
import { fileUrl } from "../../i18n/i18n";
import { clean } from "../../utils/strings";

class BlogGrid extends Component {
  state = {
    blogs: [],
    total: 0,
    page: 1,
    limit: 6,
    loading: true,
  };

  componentDidMount() {
    this.fetchBlogs();
  }

  fetchBlogs = async (page = 1) => {
    this.setState({ loading: true });

    try {
      const res = await axios.get(`${API_BASE_URL}/blog/list`, {
        params: {
          page,
          limit: this.state.limit,
          status: true,
        },
      });

      const { blogs, total } = res.data.data;

      this.setState({
        blogs,
        total,
        page,
        loading: false,
      });
    } catch (error) {
      console.error("Blog fetch error:", error);
      this.setState({ loading: false });
    }
  };

  handlePageChange = (page) => {
    if (
      page !== this.state.page &&
      page >= 1 &&
      page <= Math.ceil(this.state.total / this.state.limit)
    ) {
      this.fetchBlogs(page);
    }
  };

  render() {
    const { blogs, page, total, limit, loading } = this.state;
    const { lang } = this.props;
    const totalPages = Math.ceil(total / limit);

    return (
      <div className="ltn__blog-area ltn__blog-item-3-normal mb-100 go-top">
        <div className="container">
          <div className="row">
            {loading ? (
              <div className="text-center">
                {lang === "tr" ? "Yükleniyor..." : "Loading..."}
              </div>
            ) : (
              blogs.map((item, i) => {
                const t = item.translations?.[lang] || {};
                const bgPath = clean(item?.cover);
                const bg = bgPath ? fileUrl(API_FILE_URL, bgPath) : null;

                const dateObj = item?.date ? new Date(item.date) : null;
                const formattedDate = dateObj
                  ? dateObj.toLocaleDateString(lang, {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })
                  : "";

                return (
                  <div className="col-lg-4 col-sm-6 col-12" key={item.id}>
                    <div className="ltn__blog-item ltn__blog-item-3">
                      <div className="ltn__blog-img">
                        <Link
                          to={{
                            pathname: `/haber/${item.slug}`,
                            state: { id: item.id },
                          }}
                        >
                          <img
                            src={bg || "assets/img/blog/default.jpg"}
                            alt={t.title}
                            style={{
                              objectFit: "contain",
                              height: "200px",
                              width: "100%",
                            }}
                          />
                        </Link>
                      </div>

                      <div className="ltn__blog-brief">
                        <div className="ltn__blog-meta">
                          <ul
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <li className="ltn__blog-author">
                              <a href="#">
                                <i className="far fa-user"></i>Safkar
                              </a>
                            </li>
                          </ul>
                        </div>

                        <h3 className="ltn__blog-title blog-title-limit">
                          <Link
                            to={{
                              pathname: `/haber/${item.slug}`,
                              state: { id: item.id },
                            }}
                          >
                            {t.title}
                          </Link>
                        </h3>

                        <div className="ltn__blog-meta-btn">
                          <div className="ltn__blog-meta">
                            <ul>
                              <li className="ltn__blog-date">
                                <i className="far fa-calendar-alt" />{" "}
                                {formattedDate}
                              </li>
                            </ul>
                          </div>

                          <div
                            className="ltn__blog-btn"
                            style={{ textTransform: "none" }}
                          >
                            <Link to={`/haber/${item.slug}`}>
                              {lang === "tr" ? "Devamını Gör" : "Read More"}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {/* --- PAGINATION --- */}
          {totalPages > 1 && (
            <div className="row">
              <div className="col-lg-12">
                <div className="ltn__pagination-area text-center">
                  <div className="ltn__pagination">
                    <ul>
                      {/* PREV */}
                      <li>
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            this.handlePageChange(page - 1);
                          }}
                          className={page === 1 ? "disabled" : ""}
                        >
                          <i className="fas fa-angle-double-left" />
                        </a>
                      </li>

                      {/* NUMBERS */}
                      {[...Array(totalPages)].map((_, i) => (
                        <li key={i} className={page === i + 1 ? "active" : ""}>
                          <a
                            href="#!"
                            onClick={(e) => {
                              e.preventDefault();
                              this.handlePageChange(i + 1);
                            }}
                          >
                            {i + 1}
                          </a>
                        </li>
                      ))}

                      {/* NEXT */}
                      <li>
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            this.handlePageChange(page + 1);
                          }}
                          className={page === totalPages ? "disabled" : ""}
                        >
                          <i className="fas fa-angle-double-right" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default BlogGrid;
